import request from '@/libs/http/index'
// 获取问诊单-诊断-数据
export const getSystemTypeTree = params => {
  return request.get({
    url: `/clinic/system-type/type-tree`,
    params,
  })
}
// 获取诊断-数据
export const getSystemTypePage = params => {
  return request.get({
    url: `/clinic/system-type/page`,
    params,
  })
}
// 穴位
export const getSystemTypeParentEsList = params => {
  return request.get({
    url: `/clinic/system-type/es-parent-list`,
    params,
  })
}
// 获取诊断-数据
export const getSystemTypeEsList = params => {
  return request.get({
    url: `/clinic/system-type/es-list`,
    params,
  })
}
// 完成接诊
export const donePrescription = data => {
  return request.post({
    url: `/clinic/medical-records/done-prescription`,
    data,
  })
}
// 获取新诊号
export const getMedicalSection = () => {
  return request.get({
    url: `/clinic/medical-records/get-medical-section`,
  })
}
// 用药说明
export const instructionsPage = params => {
  return request.get({
    url: `/clinic/instructions/page`,
    params,
  })
}
// 药品说明-ES分页
export const drugsEsPage = params => {
  return request.get({
    url: `/clinic/drugs/es-page`,
    params,
  })
}
// 新增纠错记录
export const correctionRecordCreate = data => {
  return request.post({
    url: `/clinic/correction-record/create`,
    data,
  })
}
// 病历开关
export const caseItemSwitchGet = data => {
  return request.get({
    url: `/clinic/case-item-switch/get`,
    data,
  })
}
// 病历开关-恢复默认
export const caseItemSwitchDefault = params => {
  return request.get({
    url: `/clinic/case-item-switch/restore-default`,
    params,
  })
}
// 病历开关-更新
export const caseItemSwitchUpdate = data => {
  return request.put({
    url: `/clinic/case-item-switch/update`,
    data,
  })
}
// 获取医生-科室列表
export const medicalRecordsDoctor = params => {
  return request.get({
    url: `clinic/medical-records/get-doctor`,
    params,
  })
}
// 获取注意事项
export const doctorPrecautionsPage = params => {
  return request.get({
    url: `/clinic/doctor-precautions/page`,
    params,
  })
}
// 创建注意事项
export const doctorPrecautionsCreate = data => {
  return request.post({
    url: `/clinic/doctor-precautions/create`,
    data,
  })
}
// 更新注意事项
export const doctorPrecautionsUpdate = data => {
  return request.put({
    url: `/clinic/doctor-precautions/update`,
    data,
  })
}
// 删除注意事项
export const doctorPrecautionsDelete = params => {
  return request.delete({
    url: `/clinic/doctor-precautions/delete`,
    params,
  })
}
// 更新问诊
export const medicalRecordsUpdate = data => {
  return request.put({
    url: `/clinic/medical-records/update`,
    data,
  })
}
// 获取舌象
export const getByMedicalTongue = params => {
  return request.get({
    url: `/clinic/tongue-diagnosis/get-by-medical`,
    params,
  })
}
// 获取舌象结果
export const getTongueResult = params => {
  return request.get({
    url: `/clinic/tongue-diagnosis/get-result`,
    params,
  })
}
// 更新舌象图片
export const getTongueCreate = data => {
  return request.post({
    url: `/clinic/tongue-diagnosis/create`,
    data,
  })
}
// 更新舌象图片
export const getTongueUpdate = data => {
  return request.put({
    url: `/clinic/tongue-diagnosis/update`,
    data,
  })
}

// 获取辅助诊疗次数
export const getAiDiagnosisCount = params => {
  return request.get({
    url: `/clinic/ai-assisted-diagnosis/get-ai-assisted-diagnosis-count`,
    params,
  })
}

// 获取是否有会员卡项权限
export const getMembershipCard = params => {
  return request.get({
    url: `/clinic/paid-feature-dept/get-membership-card`,
    params,
  })
}

// 获取医生-科室下的挂号费
export const getRegistrationFee = params => {
  return request.get({
    url: `/clinic/registration-fee/get-fee`,
    params,
  })
}

// 根据患者和接诊医生查询初复诊
export const queryVisitStatus = data => {
  return request.post({
    url: `/clinic/medical-records/visit-status`,
    data,
  })
}

// 根据辅助诊疗返回的经方，返回经方详情
export const getPrescriptionByAi = data => {
  return request.post({
    url: `/clinic/ai-assisted-diagnosis/get-prescription-by-ai`,
    data,
  })
}
// 获取辅助诊疗日志
export const getByMedicalAiLog = params => {
  return request.get({
    url: `/clinic/ai-usage-log/get-by-medical`,
    params,
  })
}

// 智能解析病历图片
export const imgMedicalInfo = data => {
  return request.post({
    url: `/ai/bailian/chat/img-medical-info`,
    data,
    headersType: 'multipart/form-data',
  })
}

// 文本解析病历
export const textMedicalInfo = data => {
  return request.post({
    url: `/ai/bailian/chat/medical-info`,
    data,
  })
}

// 智能识方：图片或文字解析药品
export const drugInfo = data => {
  return request.post({
    url: `/ai/bailian/chat/drug-info`,
    data,
    headersType: 'multipart/form-data',
  })
}

// 获取医生排班列表
export const doctorScheduleList = params => {
  return request.get({
    url: `/clinic/medical-records/doctor-schedule-list`,
    params,
  })
}

// 保存草稿
export const draftPrescription = data => {
  return request.post({
    url: `/clinic/medical-records/save`,
    data,
  })
}
// 删除草稿
export const draftPrescriptionDelete = params => {
  return request.delete({
    url: `/clinic/medical-records/delete`,
    params,
  })
}

// 获取人文关怀
export const humanisticCaresPage = params => {
  return request.get({
    url: `/clinic/humanistic-cares/page`,
    params,
  })
}
// 创建人文关怀
export const humanisticCaresCreate = data => {
  return request.post({
    url: `/clinic/humanistic-cares/create`,
    data,
  })
}
// 更新人文关怀
export const humanisticCaresUpdate = data => {
  return request.put({
    url: `/clinic/humanistic-cares/update`,
    data,
  })
}
// 删除人文关怀
export const humanisticCaresDelete = params => {
  return request.delete({
    url: `/clinic/humanistic-cares/delete`,
    params,
  })
}

// 修改病历，方解释义专用
export const medicalRecordsUpdateRecord = data => {
  return request.post({
    url: `/clinic/medical-records/update-record`,
    data,
  })
}

// 新增穴位
export const systemTypeCreate = data => {
  return request.post({
    url: `/clinic/system-type/create`,
    data,
  })
}
// 删除穴位
export const systemTypeDelete = params => {
  return request.delete({
    url: `/clinic/system-type/delete`,
    params,
  })
}
